import React from "react";
import ReactDOM from 'react-dom';
import store from 'store';
import Artwork from '../Artwork';
import { sendArtworks, getFirstTime, getQualityFlag, getMuteFlag } from '../../pages/utils.js'
import "./home-carousel.scss";

export default class HomeFeaturedCarousel extends React.Component {
  constructor(props) {
    super(props);
    const playlist = props.playlist ? props.playlist : [];

    this.state = {
      current: 2,
      show: false,
      artworks: playlist.artworks || playlist.content.artworks,
      playlistName: playlist.name,
      artNo: 2,
      highquality: "high"
    }

    this.handleKeyDown = this.handleKeyDown.bind(this);
    // this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { playlist } = nextProps;
    this.state = {
      current: 2,
      artworks: playlist.artworks
    }

    setTimeout(() => { 
      this.setOtherList();
      this.setList();
    }, 10);
  }

  componentDidMount() {
    this.setList();
    this.checkQuality();
  }

  setList() {
    let { current, artworks } = this.state;
    if (current == artworks.length - 1 || current == artworks.length - 2) {
      var newArray = this.state.artworks.slice();
      for (let i = 0; i < artworks.length; i++) {
        newArray.push(artworks[i]);
        this.setState({
          artworks: newArray
        })
      }
    }
  }

  checkQuality() {
    if (getQualityFlag()) {
      this.setState({
        highquality: "4k"
      })
    }
    else {
      this.setState({
        highquality: "high"
      })
    }
  }

  handleKeyDown(e) {
    let isSubscribed = store.get('subscription') == "no" ? "false" : "true" || "false";
    switch (e.which) {
      case 13:
        sendArtworks(this.state.artworks, this.state.playlistName, this.state.highquality, getMuteFlag() || "false", "false", this.state.current, "true", isSubscribed);
        break;
      case 37:
        this.prev();
        break;
      case 39:
        this.next();
        break;
      case 38 :
       document.getElementById('home').focus();
    }
  }

  // handleClick() {
  //   let isSubscribed = store.get('subscription') == "no" ? "false" : "true" || "false";
  //   sendArtworks(this.state.artworks, this.state.playlistName, this.state.highquality, getMuteFlag() || "false", "false", this.state.current, "true", isSubscribed);
  // }

  next() {
    // this.setState({
    //   transition: false,
    //   artNo: 2
    // })
    // let { current } = this.state;
    const { artworks } = this.state;
    // current += 1;
    // if (current == artworks.length - 3 || current == artworks.length - 2 || current == artworks.length - 1) {
      var newArray = this.state.artworks.slice(0);
      // for (let i = 0; i < artworks.length; i++) {
        newArray.push(newArray.shift());
        this.setState({
          artworks: newArray
        })
      // }

    // }
    // this.setState({ current });
  }

  prev() {
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());
    this.setState({artworks:slides});
    // this.setState({
    //   transition: false,
    //   artNo: 1
    // })
    // let { current } = this.state;
    // const { artworks } = this.state;
    // current -= 1;
    // let k = artworks.length;
    // if (current == 1 || current == 0) {
    //   var newArray = this.state.artworks.slice();
    //   for (let i = k - 1; i >= 0; i--) {
    //     newArray.unshift(artworks[i]);
    //     this.setState({
    //       artworks: newArray
    //     })
    //     current++;
    //   }
    // }
    // this.setState({ current });
  }

  setOtherList() {
    let { current, artworks } = this.state;
    let k = artworks.length;
    var newArray1 = this.state.artworks.slice();
    for (let i = k - 1; i >= 0; i--) {
      newArray1.unshift(artworks[i]);
      this.setState({
        artworks: newArray1
      })
      current++;
    }
    this.setState({ current });
  }

  render() {
    const { current, artNo } = this.state;
    const { artworks } = this.state || {};

    if (!artworks) {
      return null
    }
    let left = (- (current + 1) * 35);
    const slides = artworks.map((item, idx) => {
      left += 35;
      return (
        <div key="idx" className="home-carousel__slide" style={{ left: `${left}%` }}>
          <Artwork focus = {this.props.focus} key={idx} showDetails={idx == current && this.state.show} artwork={item} showImage={artNo == 2 ? idx >= current - 2 && idx <= current + 3 : idx >= current - 1 && idx <= current + 3} />
        </div>
      );
    });

    return (
      <div
        tabIndex="2"
        ref="carousel"
        className="home-carousel"
        onKeyDown={this.handleKeyDown}
        onClick={this.handleClick}
        onFocus={() => this.setState({ show: true })}
        onBlur={() => this.setState({ show: false })}
      >
        {slides}
      </div>
    );
  }
}
